/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryVersionListResponse } from './RevisdomAPIViewModelsEntryVersionListResponse';
import {
    RevisdomAPIViewModelsEntryVersionListResponseFromJSON,
    RevisdomAPIViewModelsEntryVersionListResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryVersionListResponseToJSON,
    RevisdomAPIViewModelsEntryVersionListResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryVersionListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1VersionListResponse
 */
export interface ApiResponse1VersionListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1VersionListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1VersionListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryVersionListResponse}
     * @memberof ApiResponse1VersionListResponse
     */
    data?: RevisdomAPIViewModelsEntryVersionListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1VersionListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1VersionListResponse interface.
 */
export function instanceOfApiResponse1VersionListResponse(value: object): value is ApiResponse1VersionListResponse {
    return true;
}

export function ApiResponse1VersionListResponseFromJSON(json: any): ApiResponse1VersionListResponse {
    return ApiResponse1VersionListResponseFromJSONTyped(json, false);
}

export function ApiResponse1VersionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1VersionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryVersionListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1VersionListResponseToJSON(json: any): ApiResponse1VersionListResponse {
    return ApiResponse1VersionListResponseToJSONTyped(json, false);
}

export function ApiResponse1VersionListResponseToJSONTyped(value?: ApiResponse1VersionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryVersionListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

